import Axios, { AxiosRequestConfig } from 'axios';

export const CustomAxiosConfig = {
  baseUrl: 'https://termine.adventisten.cloud',
};

export const dsvApiAxiosInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  return Axios.create({ baseURL: CustomAxiosConfig.baseUrl })({ ...config }).then(({ data }) => data);
};
